module.exports = __webpack_public_path__ + "static/media/AndreasOberaigner.5dccd31b.jpg";